import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../button/Button';
import { loginPage, schedulePage, getUserLoggedIn } from '../../utils';
import { virtualPageView } from '../../googleTagManager';
import './Welcome.scss';

const Welcome = () => {
  const history = useHistory();
  const userLoggedIn = getUserLoggedIn();

  useEffect(() => {
    if (userLoggedIn) {
      history.push(schedulePage);
    }
  }, [userLoggedIn, history]);

  useEffect(() => {
    virtualPageView('plan my day', '(not set)', '/ga-virtual/plan-my-day');
  }, []);

  return (
    <div className="welcome">
      <div className="text">Book your arrival time and DineAround dining times here with this handy tool.</div>
      <div className="text">You’ll just need your:</div>
      <ul>
        <li>booking reference</li>
        <li>arrival date</li>
        <li>lead guest surname</li>
      </ul>
      <div className="see-my-experience">
        <Button type="button" text="LOG IN >" fontSize={14} onClick={() => history.push(loginPage)} />
      </div>
      <div className="text">
        Shows and activities are bookable via the Butlin’s app&nbsp;
        <a href="https://www.butlins.com/help-contact/app">
          www.butlins.com/help-contact/app
        </a>
        .
        <br />
        Download the app for the resort you are visiting now and get tapping!
      </div>
      <div className="text">
        All Travel Inspire agents will still be able to log in here to book shows and activities for your clients.
      </div>

    </div>
  );
};

export default Welcome;
